export default __webpack_public_path__ + "static/clements-4089e8b0dc39d108d35e3322ce2574fa.mp4";